
<ng-container *ngIf="answer$ | async as answer">
   <p class="t-summary" aria-live="polite" *transloco="let t" [attr.lang]="language">
      @for(wordOrNumber of answer; track wordOrNumber) {
         @if(isString(wordOrNumber)) {
            <span [innerText]="wordOrNumber + ' '"></span>
         }
         @else {
            @for(annotation of getAnnotations(wordOrNumber); track annotation) {
               <button
                  [attr.aria-label]="t('answer.sourcetitledefault', {index: annotation})"
                  [attr.title]="t('answer.sourcetitledefault', {index: annotation})"
                  [attr.aria-describedby]="'source_title_' + annotation"
                  (click)="parent.selectSource(annotation)"
                  [ngClass]="{
                     'bg-gradient-to-l from-cdra-blue-light-main from-20% to-cdra-green-main  ':
                     parent.selectedSourceIndex === annotation,
                     'bg-stone-500': parent.selectedSourceIndex !== annotation,
                  }"
                  [attr.aria-describedby]="'source_description_' + annotation"
                  class="t-source-annotation rounded-full size-4 me-1 inline-flex justify-center items-center flex-shrink-0 align-super hover:bg-gradient-to-l hover:from-cdra-blue-light-main from-20% hover:to-cdra-green-main"
               >
                  <span
                     [attr.id]="'source_description_' + annotation"
                     class="sr-only"
                  >
                     {{ t('source.details.description') }}
                  </span>
                  <span
                     aria-hidden="true"
                     class="text-white text-center text-sm font-bold"
                  >
                     {{ annotation }}
                  </span>
               </button>
            }
         }
      }
   </p>
</ng-container>